import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

export let animateScrollRevealMixinBlock = {
	initAnimateScrollReveal: (self, CLS) => {
		self.$element = self.$element || $(self.element);

		if(!_.isNil(self.$element.data('animateScrollReveal')) && self.$element.data('animateScrollReveal')) {
			self.$element.addClass(`${CLS}--animate`);
			self.$element.addClass(`${CLS}--conceal`);

			self.$tplScroller = $('.tpl-scroller');

			self.$element.on(`${CLS}.animate.conceal`, () => {
				self.$element.addClass(`${CLS}-conceal`);
				self.$element.removeClass(`${CLS}--reveal`);
			});

			self.$element.on(`${CLS}.animate.reveal`, () => {
				self.$element.addClass(`${CLS}--reveal`);
				self.$element.removeClass(`${CLS}--conceal`);
			});

			// Numbers Count (optiona - could be an extra anim element, but this is more performent)
			const numbers = self.$element.find('[data-countup]');
			if(numbers.length) {
				gsap.utils.toArray(numbers).forEach((item) => {
					$(item).text('0');
				});
			}

			if(self.$element.hasClass(`${CLS}--animate`)) {
				// GSAP Scrolltrigger (to replace existing method below)
				// const start = $(self.$element).data('animated-start') !== undefined ? $(self.$element).data('animated-start') : 'top 75%';
				ScrollTrigger.create({
					scroller: (self.$tplScroller && self.$tplScroller.length > 0) ? self.$tplScroller : window,
					trigger: self.$element,
					once: true,
					start: 'top 75%',
					// markers: true,
					onEnter: () => {
						// console.log(self.$element);
						self.$element.trigger(`${CLS}.animate.reveal`);

						// Numbers Count (optiona - could be an extra anim element, but this is more performent)
						const numbers = self.$element.find('[data-countup]');
						if(numbers.length) {
							gsap.utils.toArray(numbers).forEach((item) => {
								let numOriginal = $(item).data('countup');
								if(numOriginal) {
									numOriginal = numOriginal.toString().replace(/,/g, '');
								}
								const numCount = { val: 0 };
								setTimeout(() => {
									gsap.to(numCount, {
										val: numOriginal,
										duration: 5,
										onUpdate: function() {
											$(item).text(numCount.val.toLocaleString('en', {
												minimumFractionDigits: 0,
												maximumFractionDigits: 0
											}));
										}
									});
								}, 150);
							});
						}
					}
				});

				/*
					Disabling this due to poor performance (infinite scroll hooks), and lack of positioning options
					// Deal with latching the appropriate scroll event
					if(self.$tplScroller && self.$tplScroller.length > 0) {
						let revealBlock = () => {
							if(Math.ceil(self.$element.position().top) < (self.$element.height() / 2)) {
								self.$element.trigger(`${CLS}.animate.reveal`);
							}
						};

						self.$tplScroller.on('scroll', _.throttle(() => {
							revealBlock();
						}, 250));

						revealBlock();
					}
					else {
						let revealBlock = () => {
							let scrollBottomY = window.scrollY + window.innerHeight;

							if(scrollBottomY >= Math.ceil(self.$element.position().top) + (self.$element.height() / 2)) {
								self.$element.trigger(`${CLS}.animate.reveal`);
							}
						};
						window.addEventListener('scroll', _.throttle(() => {
							revealBlock();
						}, 250));

						revealBlock();
					}
				*/
			}
		}
	}
};


